export default __webpack_public_path__ + "static/media/growing-pot-of-wealth.0503708d.svg";